var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsLogoW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 306.53 307.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6f6f6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1w",
    "data-name": "1w"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.3 157.09 81.3 157.09 0 116.44 0 307.93 78.71 307.93 81.29 307.93 81.29 165.59 81.29 157.09 81.3 157.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "117.72 175.31 117.72 175.31 117.72 183.46 117.72 307.93 153.15 307.93 153.16 193.03 117.72 175.31"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "159.79 173.87 159.79 73.62 306.53 0 306.53 101.23 159.79 176.43 159.79 75.57"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "225.03 157.1 225.03 157.1 306.36 116.44 306.36 307.93 227.63 307.93 225.04 307.93 225.04 165.59 225.04 157.09 225.03 157.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "188.6 175.31 188.6 175.31 188.6 183.46 188.6 307.93 153.16 307.93 153.15 193.03 188.6 175.31"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "146.91 173.87 146.91 73.62 .16 0 .16 101.23 146.91 176.43 146.91 75.57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsLogoW);
export default __webpack_public_path__ + "static/media/MS-logo-W.965411b5f97894bd4f46469c73f8d118.svg";
export { ForwardRef as ReactComponent };